export const countryConfigs = {
  US: { label: 'Código HTS', extraDigits: 4 },
  CA: { label: 'CA Tariff Code', extraDigits: 4 },
  MX: { label: 'Fracción Arancelaria', extraDigits: 2 },
  CH: { label: 'CH Tariff Code', extraDigits: 2 },
  AE: { label: 'UAE HS Code', extraDigits: 6 },
  BR: { label: 'NCM Code', extraDigits: 2 },
  AT: { label: 'TARIC Code', extraDigits: 4 },
  BE: { label: 'TARIC Code', extraDigits: 4 },
  BG: { label: 'TARIC Code', extraDigits: 4 },
  HR: { label: 'TARIC Code', extraDigits: 4 },
  CY: { label: 'TARIC Code', extraDigits: 4 },
  CZ: { label: 'TARIC Code', extraDigits: 4 },
  DK: { label: 'TARIC Code', extraDigits: 4 },
  EE: { label: 'TARIC Code', extraDigits: 4 },
  FI: { label: 'TARIC Code', extraDigits: 4 },
  FR: { label: 'TARIC Code', extraDigits: 4 },
  DE: { label: 'TARIC Code', extraDigits: 4 },
  GR: { label: 'TARIC Code', extraDigits: 4 },
  HU: { label: 'TARIC Code', extraDigits: 4 },
  IE: { label: 'TARIC Code', extraDigits: 4 },
  IT: { label: 'TARIC Code', extraDigits: 4 },
  LV: { label: 'TARIC Code', extraDigits: 4 },
  LT: { label: 'TARIC Code', extraDigits: 4 },
  LU: { label: 'TARIC Code', extraDigits: 4 },
  MT: { label: 'TARIC Code', extraDigits: 4 },
  NL: { label: 'TARIC Code', extraDigits: 4 },
  PL: { label: 'TARIC Code', extraDigits: 4 },
  PT: { label: 'TARIC Code', extraDigits: 4 },
  RO: { label: 'TARIC Code', extraDigits: 4 },
  SK: { label: 'TARIC Code', extraDigits: 4 },
  SI: { label: 'TARIC Code', extraDigits: 4 },
  ES: { label: 'TARIC Code', extraDigits: 4 },
  SE: { label: 'TARIC Code', extraDigits: 4 },
  GB: { label: 'UK Tariff Code', extraDigits: 4 },
  AR: { label: 'Posición Arancelaria', extraDigits: 2 },
  NO: { label: 'NO Tariff Code', extraDigits: 2 },
  TR: { label: 'GTİP Code', extraDigits: 6 },
  AD: { label: 'AD Tariff Code', extraDigits: 2 },
  SA: { label: 'SA HS Code', extraDigits: 6 },
  KW: { label: 'KW HS Code', extraDigits: 6 },
  IL: { label: 'IL Tariff Code', extraDigits: 2 },
  AU: { label: 'AU Tariff Code', extraDigits: 2 },
  JP: { label: 'JP Statistical Code', extraDigits: 3 },
  KR: { label: 'KR HS Code', extraDigits: 4 },
  CN: { label: 'CN HS Code', extraDigits: 4 },
  SG: { label: 'SG HS Code', extraDigits: 2 },
  HK: { label: 'HK HS Code', extraDigits: 2 },
  NZ: { label: 'NZ Tariff Code', extraDigits: 2 },
  TH: { label: 'TH Tariff Code', extraDigits: 2 },
  CL: { label: 'CL Tariff Code', extraDigits: 2 },
  CO: { label: 'CO Subpartida', extraDigits: 4 },
  TT: { label: 'TT HS Code', extraDigits: 2 },
  EG: { label: 'EG HS Code', extraDigits: 0 },
}

export const disabledHelperText =
  'Para habilitar este campo, introduzca primero el código HS en la sección «Detalles del producto» situada más arriba.'

export const europeanUnionCountryCodes = [
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
]

export const europeanUnionCustomsConfig = { label: 'Código TARIC', extraDigits: 4 }
